import { FormType } from '../../../form-types';

export const unisexHairLoss: FormType = {
  name: 'General Hair Loss Visit',

  questions: [
    {
      key: 'unisexHairLoss_sexAssignedAtBirth',
      next: {
        condition: {
          'unisexHairLoss_sexAssignedAtBirth.unisexHairLoss_sexAssignedAtBirth_female':
            true
        },
        key: 'unisexHairLoss_postmenopausal',
        els: 'unisexHairLoss_maleConditions'
      }
    },
    {
      key: 'unisexHairLoss_maleConditions',
      next: {
        condition: {
          'unisexHairLoss_sexAssignedAtBirth.unisexHairLoss_sexAssignedAtBirth_male':
            true
        },
        key: 'unisexHairLoss_affectedAreas',
        els: 'unisexHairLoss_postmenopausal'
      }
    },
    'unisexHairLoss_postmenopausal',
    {
      key: 'unisexHairLoss_pregnancy',
      next: {
        condition: {
          'unisexHairLoss_pregnancy.unisexHairLoss_pregnancy_yes': true
        },
        key: 'unisexHairLoss_ineligible',
        els: 'unisexHairLoss_pregnancyConsent'
      }
    },
    {
      key: 'unisexHairLoss_pregnancyConsent',
      next: {
        condition: {
          'unisexHairLoss_pregnancyConsent.unisexHairLoss_pregnancyConsent_disagree':
            true
        },
        key: 'unisexHairLoss_ineligible',
        els: 'unisexHairLoss_affectedAreas'
      }
    },
    {
      key: 'unisexHairLoss_affectedAreas',
      next: {
        condition: {
          'unisexHairLoss_affectedAreas.unisexHairLoss_affectedAreas_other':
            true
        },
        key: 'unisexHairLoss_hairLossPattern',
        els: 'unisexHairLoss_duration'
      }
    },
    'unisexHairLoss_hairLossPattern',
    'unisexHairLoss_duration',
    {
      key: 'unisexHairLoss_evaluatedByPhysician',
      next: {
        condition: {
          'unisexHairLoss_evaluatedByPhysician.unisexHairLoss_evaluatedByPhysician_yes':
            true
        },
        key: 'unisexHairLoss_diagnosis',
        els: 'unisexHairLoss_scalpConditions'
      }
    },
    {
      key: 'unisexHairLoss_diagnosis',
      next: {
        condition: {
          'unisexHairLoss_diagnosis.unisexHairLoss_diagnosis_other': true
        },
        key: 'unisexHairLoss_diagnosisDetails',
        els: 'unisexHairLoss_scalpConditions'
      }
    },
    'unisexHairLoss_diagnosisDetails',
    'unisexHairLoss_scalpConditions',
    'unisexHairLoss_scalpIrritation',
    {
      key: 'unisexHairLoss_bodyHairLoss',
      next: {
        condition: {
          'unisexHairLoss_bodyHairLoss.unisexHairLoss_bodyHairLoss_yes': true
        },
        key: 'unisexHairLoss_bodyHairLossDetails',
        els: 'unisexHairLoss_previousTreatment'
      }
    },
    'unisexHairLoss_bodyHairLossDetails',
    {
      key: 'unisexHairLoss_previousTreatment',
      next: {
        condition: {
          'unisexHairLoss_previousTreatment.unisexHairLoss_previousTreatment_yes':
            true
        },
        key: 'unisexHairLoss_previousTreatmentDetails',
        els: 'unisexHairLoss_medicalConditionsSpecific'
      }
    },
    'unisexHairLoss_previousTreatmentDetails',
    'unisexHairLoss_medicalConditionsSpecific',
    {
      key: 'unisexHairLoss_moodDisorders',
      next: {
        condition: {
          'unisexHairLoss_moodDisorders.unisexHairLoss_moodDisorders_yes': true
        },
        key: 'unisexHairLoss_moodDisordersDetails',
        els: 'unisexHairLoss_additionalInfo'
      }
    },
    'unisexHairLoss_moodDisordersDetails',
    'unisexHairLoss_additionalInfo',
    {
      key: 'unisexHairLoss_truthfulnessConsent',
      next: {
        condition: {
          'unisexHairLoss_truthfulnessConsent.unisexHairLoss_truthfulnessConsent_disagree':
            true
        },
        key: 'unisexHairLoss_ineligible',
        els: 'unisexHairLoss_treatmentConsent'
      }
    },
    {
      key: 'unisexHairLoss_treatmentConsent',
      next: {
        condition: {
          'unisexHairLoss_treatmentConsent.unisexHairLoss_treatmentConsent_disagree':
            true
        },
        key: 'unisexHairLoss_ineligible',
        els: 'unisexHairLoss_complete'
      }
    },
    'unisexHairLoss_ineligible',
    'unisexHairLoss_complete'
  ]
};
